export default __webpack_public_path__ + "static/media/bci-10-hover.e83bce23.svg";